import { axios } from '$app-web/api/axios';

import { Endpoints } from '../constant';

export async function updatePassword(currentPassword: string, newPassword: string) {
    const data = { cur_password: currentPassword, password: newPassword };

    try {
        const { status } = await axios.post(Endpoints.User.Password, data);

        return status === 200;
    } catch {
        return false;
    }
}
